import React from 'react';
import { motion } from 'framer-motion';
import { HeadphonesIcon, SettingsIcon, CheckIcon, HashIcon } from 'lucide-react';
export function Personas() {
  return <section className="py-28 md:py-36" data-id="element-278" data-mp="3jnyp2won7dq2">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12" data-id="element-279" data-mp="3okyud5do4cg4">
        {/* Left-aligned header for variety */}
        <div className="mb-16 max-w-2xl" data-id="element-280" data-mp="3tlcqbp1zvvxs">
          <div className="text-xs uppercase tracking-[0.2em] font-medium text-teal-600 mb-4" data-id="element-281" data-mp="3thypwmcw5wsz">
            Built for your team
          </div>
          <h2 className="text-3xl md:text-4xl font-medium text-slate-900 mb-4" data-id="element-282" data-mp="6etwo2an6va8">
            Zero friction for reps. Total control for admins.
          </h2>
          <p className="text-base text-slate-600 font-normal" data-id="element-283" data-mp="b8ofl3ifb689">
            Reps don't even know it's there. Admins get perfect, structured data
            synced directly to HubSpot.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-284" data-mp="p639oljmg26k">
          {/* Sales Reps */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-xl p-10 border border-slate-200 shadow-sm flex flex-col" data-id="element-285" data-mp="30j56894ifo0h">
            <div className="w-12 h-12 bg-slate-100 border border-slate-200 rounded-lg flex items-center justify-center mb-8" data-id="element-286" data-mp="3j8l7iyo0rkhy">
              <HeadphonesIcon className="w-6 h-6 text-slate-600" data-id="element-287" data-mp="3eb1s3vfl51of" />
            </div>
            <h3 className="text-2xl font-medium text-slate-900 mb-8" data-id="element-288" data-mp="39iig32wjqelq">
              For Sales Reps
            </h3>
            <ul className="space-y-4 mb-8 flex-1" data-id="element-289" data-mp="34kgmho1huww0">
              {['Nothing changes about how you sell. Just keep taking calls', 'Deal notes appear in HubSpot before your next meeting starts', 'No app to learn, no tabs to open, no forms to fill', 'Back-to-back calls? Every detail is captured automatically'].map((item, i) => <li key={i} className="flex items-start" data-id="element-290" data-mp="20d1crk33mryh" data-mpi={i}>
                  <CheckIcon className="w-5 h-5 text-teal-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-291" data-mp="1ll0ykk40o94k" />
                  <span className="text-slate-600 font-normal text-base leading-relaxed" data-id="element-292" data-mp="1qkdhwuvoiy2e">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* RevOps */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.05
        }} className="bg-white rounded-xl p-10 border border-slate-200 shadow-sm flex flex-col" data-id="element-293" data-mp="1goafdnwx0xex">
            <div className="w-12 h-12 bg-slate-100 border border-slate-200 rounded-lg flex items-center justify-center mb-8" data-id="element-294" data-mp="qe0ajgmhzlb2">
              <SettingsIcon className="w-6 h-6 text-slate-600" data-id="element-295" data-mp="lfozx3odp6rs" />
            </div>
            <h3 className="text-2xl font-medium text-slate-900 mb-8" data-id="element-296" data-mp="103js8iyh594c">
              For RevOps & Admins
            </h3>
            <ul className="space-y-4 mb-8 flex-1" data-id="element-297" data-mp="v9ytupsyyd4m">
              {['Set up once. Configure frameworks, field mapping, and review rules', 'Never chase reps for CRM updates again', '100% deal data completeness without any rep behavior change', 'Enterprise-grade controls: SSO, retention policies, audit logs'].map((item, i) => <li key={i} className="flex items-start" data-id="element-298" data-mp="1e0oyaiy6u7zl" data-mpi={i}>
                  <CheckIcon className="w-5 h-5 text-teal-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-299" data-mp="3ktsevjv462xc" />
                  <span className="text-slate-600 font-normal text-base leading-relaxed" data-id="element-300" data-mp="3fuxxmmcsomfc">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}